import { SelfService } from '~/types/technicalSupport';
import apiAssist from '~/utils/apiAssist';

export const newService = async (): Promise<SelfService> => {
  const { data } = await apiAssist.post<SelfService>('/atendimento/');
  return {
    ...data,
    current_messages:
      data.message.length > 0
        ? data.messages.slice(data.message.length * -1)
        : [],
  };
};

export const service = async (
  message: string,
  uuid: string,
  current_index: number,
): Promise<SelfService> => {
  const { data } = await apiAssist.post(`/atendimento/${uuid}/`, {
    message,
  });
  return {
    ...data,
    current_messages:
      data.message.length > 0 ? data.messages.slice(current_index + 1) : [],
  };
};

export const evaluateService = async (
  rating: number,
  uuid: string,
  ratingReason?: string,
): Promise<SelfService> => {
  const { data } = await apiAssist.post(`/atendimento/${uuid}/avaliacao/`, {
    metadata: { rating, ratingReason },
  });
  return {
    ...data,
    current_messages:
      data.message?.length > 0
        ? data.messages.slice(data.message.length * -1)
        : [],
  };
};
